import { render, staticRenderFns } from "./UpdateClientModal.vue?vue&type=template&id=b15e6cba&"
import script from "./UpdateClientModal.vue?vue&type=script&lang=js&"
export * from "./UpdateClientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports